import { SETTING } from "../config";
import { get } from "./apiHelper";

export const fetchSettings = (settingType) => get(`${SETTING}${settingType}`);
